import React from 'react'

import { MChatRfResultadoView } from '../../components/MChatRfResultadoView'
import { ConsultaSeguimentoResultadoMap, ConsultaSeguimentoViewModel } from '../model-consultaSeguimento'
import { getResultadoLabel } from '../utils-consultaSeguimento'

interface ConsultaSeguimentoResultadoViewProps {
  value: ConsultaSeguimentoViewModel
}

export function ConsultaSeguimentoResultadoView(props: Readonly<ConsultaSeguimentoResultadoViewProps>) {
  const { value } = props

  const { type, title, encaminhamento } = ConsultaSeguimentoResultadoMap[value.resultado]

  const label = getResultadoLabel(value)

  return (
    <MChatRfResultadoView
      type={type}
      title={title}
      description={encaminhamento}
      label={label}
      footerInfo={value.footerInfo}
    />
  )
}
